<template>
    <section class="user">
        <div class="title_wrap">
            <span class="title_name">资料与账号</span>
        </div>
        <div class="userinfo">
          <div class="subtitle_wrap">
            <span class="subtitle">基本信息</span>
          </div>
          <div class="rowinfo">
              <span class="fadespan">用户名</span>
              <span class="shenspan">{{user.username}}</span>
          </div>
          <div class="rowinfo">
              <span class="fadespan">姓名</span>
              <span class="shenspan">{{user.name}}</span>
          </div>
          <div class="rowinfo">
              <span class="fadespan">联络电话</span>
              <span class="shenspan">{{user.phone}}</span>
          </div>
          <div class="rowinfo">
              <span class="fadespan">地址</span>
              <span class="shenspan">{{user.addr}}</span>
          </div>
          <div class="rowinfo">
              <span class="fadespan">邮箱</span>
              <span class="shenspan">{{user.email}}</span>
          </div>
          <div class="rowinfo">
              <span class="fadespan">指导老师</span>
              <span class="shenspan">{{user.teacher}}</span>
          </div>
          <div class="rowinfo">
              <span class="fadespan">专业</span>
              <span class="shenspan">{{user.major}}</span>
          </div>
          <div class="rowinfo">
              <span class="fadespan">编号</span>
              <span class="shenspan">{{user.userid}}</span>
          </div><div class="rowinfo">
              <span class="fadespan">学校</span>
              <span class="shenspan">{{user.school}}</span>
          </div>
          <div class="rowinfo">
              <span class="fadespan">学校所在省份</span>
              <span class="shenspan">{{user.province}}</span>
          </div>
          <div class="rowinfo">
              <span class="fadespan">个人生活照</span>
              <span class="shenspan" v-if="user.avatar_url != ''"><img :src="url +'/assets/upload/' + user.avatar_url"></img></span>
              <span class="shenspan" v-else>无</span>
          </div>
          <div style="position:relative;left:800px;top:-60px;"  class="changeInfo" ><a href="#/changeInfo">修改基本信息</a></div>
          <div style="margin-top:40px;">
            <div style="color:black;padding-bottom:10px;font-size:14px;border-bottom:1px solid #f2f6fa;margin-bottom:20px;">账号安全</div>
            <div class="clearfix" style="margin-bottom:60px;">
              <div style="height:40;line-height:40px;color:black;font-size:12px;">
                  <span class="fadespan">登陆密码</span><span style="margin-left:15px;">密码建议包含字母，符号或数字中的两项且长度超过8位，以保证账号更加安全。</span>
              </div>
              <div class="changePwd" @click="changePwd" style="position:relative;top:-40px;left:800px;">修改密码</div>
            </div>
          </div>
       </div>
       
    </section>
</template>
<script>
import axios from 'axios'

export default {
  data () {
    return {
      token: '',
      url: this.API,
      groupInfo: [],
      user: []
    }
  },
  computed: {
  },
  created () {
  },
  mounted () {
    this._getData()
  },
  filters: {
  },
  methods: {
    changePwd: function(){
         let _t = this
         _t.$router.push({name:'UserChangePwd', params:{email:_t.user.email, username: _t.user.username}})
    },
    _getData: function () {
      let _t = this
      _t.token = _t.$ls.get('token')
      axios.post(_t.API + '/api/user/all', {token: _t.token})
        .then(function (resp) {
          if (resp.data.code === '401') {
            _t.$router.push('/login/')
            return
          }
          if (resp.data.code === '0') {
            _t.user = resp.data.user
          } else {
            _t.$messagewarning(resp.data.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
    
</script>

<style scoped lang='stylus'>
@import '~@/common/stylus/index'

.clearfix:after{
  content:"";
  display: table;
  clear:both;
}
.clearfix{
  *zoom: 1;
}
.user{
    padding: 50px calc((100% - 1024px) / 2);
}
.title_wrap{
    border-bottom: 1px solid #a3a3a3;
    margin-bottom: 5px;
    text-align: left;
    position: relative;
}
.title_name{
    font-family: sy;
    border-bottom: 4px solid #25335e;
    color: black;
    font-weight:600;
    font-size: 20px;
}
.subtitle{
    text-align:left;
    width: 90px;
    font-size: 14px;
    padding-bottom:10px;
}
.userinfo{
    /*margin: 60px auto 0;*/
    position: relative;
    margin-top: 20px;
}
.bottom{
    margin-top:20px;
}
.shenspan{
    font-family: sylight;
    font-size: 14px;
    display: inline-block;
    color:black;
    text-align:left;
    margin-left: 15px;
}
.fadespan{
    font-family: sylight;
    font-size: 14px;
    display: inline-block;
    text-align: right;
    color:gray;
    width:90px;
}
.most{
    font-family: sylight;
    font-size: 14px;
    display: inline-block;
    color:black;
    text-align: left;
    margin-left: 15px;
}
.different{
    vertical-align: top;
}
input[type='button']{
    width: 200px;
    height: 50px;
    background:rgba(22, 155, 213, 1);
    color:white;
    font-size:14px;
    line-height: 50px;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
}
.changemail{
    margin-top: 30px;
}
.changeinfo{
    margin-top: 200px;
}
.changepwd{
    margin-top: 60px;
}
.disabled input{
    background: gray;
}

.rowinfo{
    display: block;
    margin-bottom: 10px;
    margin-top: 20px;
}
.changeInfo{
  width: 150px;
  height: 40px;
  background: #25335e;
  border-radius: 2px;
  text-align: center;
  line-height: 40px;
  font-size: 14px;
  font-family: sy;
}
.changeInfo>a{
  width: 100%;
  height: 100%;
  color:white;
  display: inline-block;
}
.subtitle_wrap{
  border-bottom: 1px solid #f2f6fa;
}
.changeMail{
  width: 150px;
  height: 40px;
  background: #25335e;
  border-radius: 2px;
  text-align: center;
  line-height: 40px;
  font-size: 14px;
  font-family: sy;
  position: absolute;
  top:65px;
  left: 800px;
}
.changeMail>a{
  color:white;
}
section.user{
  margin:0 auto;
  width: 100%;
}
.changePwd{
  width: 150px;
  height: 40px;
  background: #25335e;
  border-radius: 2px;
  text-align: center;
  line-height: 40px;
  font-size: 14px;
  font-family: sy;
  color:white;
}

</style>



// WEBPACK FOOTER //
// User.vue?793e64b6